import constantsRedline from "./redline";
import constantsAuth from "./auth";
import constantsLegacyAuth from "./legacyAuth";
import constantsRiachuelo from "./riachuelo";
import cookies from "./cookies";
import constantsDebts from "./debts";
import constantsLoans from "./loans";
import constantsCustomEvents from './customEvents';
import constantsUnlockFeatureTag from "./unlockFeatureTag";

const constants = {
  auth: constantsAuth,
  cookies: cookies,
  legacyAuth: constantsLegacyAuth,
  redline: constantsRedline,
  riachuelo: constantsRiachuelo,
  debts: constantsDebts,
  loans: constantsLoans,
  customEvents: constantsCustomEvents,
	unlockFeatureTag: constantsUnlockFeatureTag,
}

export default constants
